export enum StatusCode {
  OK = 0,
  UNAUTHENTICATED = 16,
  NOT_FOUND = 13,
}
